// Scroll animation from https://stackoverflow.com/a/39494245
export function scrollToElement(target, duration = 300, offset = 0) {
  if (target && target.getBoundingClientRect) {
    const startingY = window.pageYOffset;
    const diff = target.getBoundingClientRect().top + offset;
    const bottomOfPage = startingY + window.innerHeight >= document.body.offsetHeight;

    if (!(bottomOfPage && diff > 0)) {
      let start;
      window.requestAnimationFrame(function step(timestamp) {
        if (!start) start = timestamp;

        // Elapsed miliseconds since start of scrolling.
        const time = timestamp - start;

        // Get percent of completion in range [0, 1].
        const percent = Math.min(time / duration, 1);
        window.scrollTo(0, startingY + (diff * percent));
        // Proceed with animation as long as we wanted it to.
        if (time < duration) {
          window.requestAnimationFrame(step);
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils.js